import * as React from 'react';

import {useTranslation} from '@deviceinsight/ng-ui-scale-lib/api';

type Props = {
	onChange: (...args: Array<any>) => any;
	value: string;
	options: Record<string, string>;
	toFilter?: Array<string>;
	disabled?: boolean;
	// if a prefix is set, the option value is translated with the i18n key {prefix} + key
	translatePrefix?: string;
	'data-testid'?: string;
};
type OptionProps = {
	optionKey: string;
	options: Record<string, string>;
	translatePrefix?: string;
};

const Option = ({optionKey, options, translatePrefix}: OptionProps) => {
	const {t} = useTranslation();
	const i18nKey = translatePrefix ? `${translatePrefix}${optionKey}` : optionKey;
	return (
		<option key={optionKey} value={options[optionKey]}>
			{t(i18nKey, {
				defaultValue: optionKey
			})}
		</option>
	);
};

const EnumDropdown = ({onChange, toFilter, value, options, disabled, translatePrefix, ...rest}: Props) => {
	return (
		<select
			data-testid={rest['data-testid']}
			value={value}
			disabled={disabled}
			onChange={(e) => {
				onChange(e.target.value);
			}}>
			{Object.keys(options)
				.filter((key) => !(toFilter || []).includes(key))
				.map((key) => {
					return <Option optionKey={key} key={key} options={options} translatePrefix={translatePrefix} />;
				})}
		</select>
	);
};

export default EnumDropdown;
